import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { nameof } from 'ts-simple-nameof';
import { DialogSubscriptionComponent } from '../../../../dialog/dialog-subscription.component';
import { DialogService } from '../../../../dialog/dialog.service';
import { ValidGradingRankCode } from '../../../../shared/interface/valid-grading-rank-code.interface';
import { ValidStaffCode } from '../../../../shared/interface/valid-staff-code.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { nameofExt } from '../../../../shared/services/nameof-extend';
import { TableStateService } from '../../../../tables/table-state.service';
import {
    ActionButtonClickEvent,
    ActionComplete,
    ColumnDefinition,
    TableFilterItem
} from '../../../../tables/table.types';
import { FacultyStaffTypeEditComponent } from './faculty-staff-type-edit/faculty-staff-type-edit.component';
import { FacultyStaffTypeService } from './faculty-staff-type.service';

@Component({
    selector: 'app-registrar-admin-maintenance-faculty-staff-type',
    templateUrl: './faculty-staff-type.component.html',
    styleUrls: ['./faculty-staff-type.component.scss']
})
export class FacultyStaffTypeComponent extends DialogSubscriptionComponent implements OnInit {
    tableName: string = 'faculty_category';
    baseUrl: string = 'validStaffCode';
    filters: Array<TableFilterItem> = [
        {
            property: nameof<ValidStaffCode>((m) => m.staffCode),
            inputType: 'input'
        },
        {
            property: nameof<ValidStaffCode>((m) => m.title),
            inputType: 'input'
        },
        {
            property: nameof<ValidStaffCode>((m) => m.isEnabled),
            inputType: 'select',
            clearButton: true,
            selectOptions: of([
                {
                    text: 'Yes',
                    value: 'YES'
                },
                {
                    text: 'No',
                    value: 'NO'
                }
            ])
        }
    ];
    columns: Array<ColumnDefinition> = [
        {
            property: nameof<ValidStaffCode>((m) => m.id)
        },
        {
            property: nameof<ValidStaffCode>((m) => m.staffCode)
        },
        {
            property: nameof<ValidGradingRankCode>((m) => m.title),
            disableSort: true
        },
        {
            property: nameof<ValidStaffCode>((m) => m.isEnabled),
            booleanAsYesNo: true
        },
        {
            property: nameof<ValidStaffCode>((m) => m.dateCreated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: nameof<ValidStaffCode>((m) => m.createdByName),
            disableSort: true
        },
        {
            property: nameof<ValidStaffCode>((m) => m.lastUpdated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: nameof<ValidStaffCode>((m) => m.lastUpdatedByName),
            disableSort: true
        },
        {
            property: 'actions',
            actions: [
                {
                    discriminator: 'edit',
                    icon: 'edit',
                    toolTip: `Click to edit ${nameofExt<ValidStaffCode>((m) => m.staffCode)}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<ValidStaffCode>) => {
                            return this.service.show(event.element.id);
                        },
                        function: this.show
                    }
                },
                {
                    discriminator: 'delete',
                    icon: 'delete',
                    toolTip: `Click to delete ${nameofExt<ValidStaffCode>((m) => m.staffCode)}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<ValidStaffCode>) => {
                            return this.service.delete(event.element.id);
                        },
                        function: (event: ActionButtonClickEvent<ValidStaffCode>) => {
                            this.alert.toastSuccess(`${event.element.staffCode} deleted!`);
                            this.tableState.sendToTable({
                                tableName: this.tableName,
                                element: event.element,
                                remove: true
                            });
                            return {
                                completed: true
                            };
                        }
                    }
                }
            ]
        }
    ];
    constructor(
        private dialog: DialogService<ValidStaffCode>,
        private service: FacultyStaffTypeService,
        private alert: AlertService,
        private tableState: TableStateService
    ) {
        super();
    }

    ngOnInit(): void {}

    show(event: ActionButtonClickEvent<ValidStaffCode> = null): ActionComplete {
        const element = event?.observableValue ?? { id: -1 };
        this.addSubscription(
            this.dialog.response.subscribe((v) => {
                if (v.dialogAlias === 'validStaffCode') {
                    this.tableState.sendToTable({
                        tableName: this.tableName,
                        element: v.payload,
                        update: true
                    });
                }
            }),
            this.dialog.show(element, {
                component: FacultyStaffTypeEditComponent,
                dialogAlias: 'validStaffCode',
                title: element.id === -1 ? 'New Staff Code' : `${element.staffCode} ${element.title}`,
                uniqueId: `validStaffCode${element.id}`
            })
        );
        return {
            completed: true
        };
    }
}
